// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1l9Ns","inputDescription":"styles_inputDescription__3eZjU"};